import pino from 'pino';

const Logger = pino({ browser: { asObject: true } });
export default Logger;
